export default __webpack_public_path__ + "static/Graphik-Semibold-Web-bd953175586be631c9ed728303904e88.svg";